export default ({ app, router, store, Vue }) => {
  router.beforeEach((to, from, next) => {
    if (to.meta.unprotected) {
      return next()
    }

    store.dispatch('check')
      .then(() => {
        const authenticated = store.getters.authenticated

        // Todo: if route meta is missing this ends in an infinite loop
        if (to.meta.guestsOnly && authenticated) {
          next('/')
        } else if (to.meta.guestsOnly || authenticated) {
          store.dispatch('parseTeamFromRoute', to, next)
            .then(() => {
              if (to.meta.roleRequired && store.getters.user.role > to.meta.role) {
                next('403')
              } else {
                next()
              }
            })
            .catch(() => next('/404'))
        } else {
          next('/login')
        }
      })
      .catch(() => {
        next('/login')
      })
  })
}
